// extracted by mini-css-extract-plugin
export default {"headerCard":"FileUploadStatus_headerCard__R77-P","headerTitle":"FileUploadStatus_headerTitle__LJV5d","container":"FileUploadStatus_container__td8Ae"};